import { tsUtils } from '@neo-one/ts-utils';
import { BuiltinInstanceMemberCall } from './BuiltinInstanceMemberCall';
export class BuiltinSlotInstanceMemberCall extends BuiltinInstanceMemberCall {
    constructor(type, slot) {
        super();
        this.type = type;
        this.slot = slot;
    }
    canCall() {
        return true;
    }
    emitCall(sb, func, node, optionsIn, visited) {
        const options = sb.pushValueOptions(optionsIn);
        if (!visited) {
            sb.visit(tsUtils.expression.getExpression(func), options);
        }
        sb.emitHelper(node, options, sb.helpers.unwrapVal({ type: this.type }));
        sb.emitPushInt(node, this.slot);
        sb.emitOp(node, 'PICKITEM');
        sb.emitPushInt(node, 0);
        sb.emitOp(node, 'NEWARRAY');
        sb.emitOp(node, 'SWAP');
        sb.emitHelper(node, optionsIn, sb.helpers.call);
    }
}

//# sourceMappingURL=BuiltinSlotInstanceMemberCall.js.map
